interface FacilitiesProps {
  facilities: string[];
}

export default function Facilities({ facilities }: FacilitiesProps) {
  return (
    <div className="bg-white mt-2 px-5 py-4">
      <div className="text-sm font-semibold text-gray-800 mb-3">酒店设施</div>
      <div className="flex flex-wrap gap-2">
        {facilities.map((f) => (
          <span key={f} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs" style={{ background: "#F3F4F6", color: "#374151" }}>
            <i className="ri-checkbox-circle-line" style={{ color: "#10B981", fontSize: 12 }} />{f}
          </span>
        ))}
      </div>
    </div>
  );
}
